import {
  USER_CSV_DOWNLOAD, USER_CSV_DOWNLOAD_FAILURE, USER_CSV_DOWNLOAD_SUCCESS
} from './mutation-types'

export default {
  state: {
    csvDownload: [],
    csvShops: [],
    csvUsertypes: []
  },
  getters: {
    csvDownload: state => {
      return state.csvDownload
    },
    csvShops: state => {
      return state.csvShops
    },
    csvUsertypes: state => {
      return state.csvUsertypes
    }
  },
  actions: {
    [USER_CSV_DOWNLOAD] ({dispatch, state, commit}, params = null) {
      console.log('USER_CSV_DOWNLOAD')
      var callback = () => {}
      var data = {}
      if (params) {
        data = params.data
        callback = params.callback
      }
      dispatch('apiGet', { url: '/master/csv_download', data: data })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(USER_CSV_DOWNLOAD_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(USER_CSV_DOWNLOAD_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [USER_CSV_DOWNLOAD_FAILURE] (state, data) {
      console.log('USER_CSV_DOWNLOAD_FAILURE')
    },
    [USER_CSV_DOWNLOAD_SUCCESS] (state, data) {
      console.log('USER_CSV_DOWNLOAD_SUCCESS')
      state.csvDownload = data.data.csv_datas.data
      state.csvShops = data.data.shop_histories.data
      state.csvUsertypes = data.data.user_type_histories.data
      data.callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/csv-download.js